export default "__VITE_ASSET__DJooaQKg__"